module.exports = `:root {
  --primitiveColorCyanBase: #00b4f1;
  --primitiveColorCyanDark25: #000b0f;
  --primitiveColorCyanDark50: #00131a;
  --primitiveColorCyanDark100: #001f29;
  --primitiveColorCyanDark150: #002a38;
  --primitiveColorCyanDark200: #003547;
  --primitiveColorCyanDark250: #004156;
  --primitiveColorCyanDark300: #004d67;
  --primitiveColorCyanDark375: #005f80;
  --primitiveColorCyanDark450: #00739a;
  --primitiveColorCyanLight550: #008ebe;
  --primitiveColorCyanLight625: #00a2d9;
  --primitiveColorCyanLight687: #00b4f1;
  --primitiveColorCyanLight750: #3fc7f4;
  --primitiveColorCyanLight800: #68d4f7;
  --primitiveColorCyanLight850: #93dff9;
  --primitiveColorCyanLight900: #b9eafb;
  --primitiveColorCyanLight950: #ddf5fd;
  --primitiveColorCyanLight975: #eefafe;
  --primitiveColorGreenBase: #73c166;
  --primitiveColorGreenDark25: #060a05;
  --primitiveColorGreenDark50: #0b130a;
  --primitiveColorGreenDark100: #121f10;
  --primitiveColorGreenDark150: #192a16;
  --primitiveColorGreenDark200: #20361c;
  --primitiveColorGreenDark250: #274223;
  --primitiveColorGreenDark300: #2f4e29;
  --primitiveColorGreenDark375: #3a6234;
  --primitiveColorGreenDark450: #46763e;
  --primitiveColorGreenLight550: #57914d;
  --primitiveColorGreenLight625: #63a758;
  --primitiveColorGreenLight713: #73c166;
  --primitiveColorGreenLight750: #85c97a;
  --primitiveColorGreenLight800: #9ed495;
  --primitiveColorGreenLight850: #b7dfb0;
  --primitiveColorGreenLight900: #cfeacb;
  --primitiveColorGreenLight950: #e7f4e5;
  --primitiveColorGreenLight975: #f3faf2;
}
`;